import { render, staticRenderFns } from "./EditContactForm.vue?vue&type=template&id=ef529b78&"
import script from "./EditContactForm.vue?vue&type=script&lang=ts&"
export * from "./EditContactForm.vue?vue&type=script&lang=ts&"
import style0 from "./EditContactForm.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports